import { useState } from 'react'
import { IconeAlerta, IconeInfo } from '../icones'
import { FolhaInferior } from './FolhaInferior'
import { MarcaRescueLab } from './MarcaRescueLab'

/**
 * Conteúdo da página Sobre. É AQUI que se fala do sistema e da equipe —
 * editar estas duas constantes é editar a página inteira, sem mexer em JSX.
 */
const DESCRICAO_SISTEMA =
  'RESCUE-LAB é um laboratório didático 3D de salvamento veicular, ' +
  'para treino de bombeiros e estudantes da área de emergência. Simula cinemática de ' +
  'acidentes, estabilização veicular, manejo de vidros, técnicas de corte, planejamento ' +
  'de extração e atendimento à vítima, num ambiente 3D interativo que o aluno manipula ' +
  'diretamente, e não um vídeo ou um slide.'

interface MembroEquipe {
  nome: string
  papel: string
}

/** Um item por pessoa. Adicionar alguém na equipe é acrescentar uma linha aqui. */
const EQUIPE: readonly MembroEquipe[] = [
  { nome: 'Marco Guerra', papel: 'Desenvolvimento' },
]

/** "Marco Guerra" → "MG": o monograma que faz as vezes de avatar. */
function iniciais(nome: string) {
  const partes = nome.trim().split(/\s+/)
  const primeira = partes[0]?.[0] ?? ''
  const ultima = partes.length > 1 ? partes[partes.length - 1][0] : ''
  return (primeira + ultima).toUpperCase()
}

export function Sobre() {
  const [aberta, setAberta] = useState(false)

  return (
    <>
      <button
        type="button"
        className="tema-no-topo"
        onClick={() => setAberta(true)}
        aria-label="Sobre o RESCUE-LAB"
        title="Sobre o RESCUE-LAB"
      >
        <IconeInfo tamanho={18} />
      </button>

      <FolhaInferior
        aberta={aberta}
        titulo="Sobre o RESCUE-LAB"
        aoFechar={() => setAberta(false)}
        fracaoAltura={0.7}
        className="sobre"
      >
        <MarcaRescueLab variante="logo" className="sobre__marca" />

        <p className="sobre__descricao">{DESCRICAO_SISTEMA}</p>

        <section className="sobre__secao" aria-labelledby="sobre-equipe">
          <h3 id="sobre-equipe" className="sobre__titulo-secao">Equipe</h3>
          <ul className="sobre__equipe">
            {EQUIPE.map((membro) => (
              <li key={membro.nome}>
                <span className="sobre__monograma" aria-hidden="true">
                  {iniciais(membro.nome)}
                </span>
                <span className="sobre__membro">
                  <strong>{membro.nome}</strong>
                  <span>{membro.papel}</span>
                </span>
              </li>
            ))}
          </ul>
        </section>

        <p className="sobre__aviso" role="note">
          <IconeAlerta tamanho={16} />
          <span>Apoio a treinamento. Não substitui doutrina, instrutor nem protocolo operacional.</span>
        </p>

        <p className="sobre__direitos">
          © 2026 Marco Guerra. Todos os direitos reservados. Software proprietário: não é permitido copiar, hospedar,
          modificar ou redistribuir o código, os cenários ou os textos sem autorização escrita.
        </p>

        <p className="sobre__creditos">
          Desenvolvido por{' '}
          <a
            href="https://marcoguerra.dev.br"
            target="_blank"
            rel="noreferrer"
            className="marca-digital-bricks"
          >
            <img
              src="/marco-guerra.png"
              alt=""
              aria-hidden="true"
              className="marca-digital-bricks__logo"
            />
            <span>Marco Guerra</span>
          </a>
        </p>
      </FolhaInferior>
    </>
  )
}
